import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/blog-collection";
import { slugOf } from "@common/schema/blog-post/slug";

// The name follows the title the way a post's slug does — see posts/new.
export const followTitle = ({ value, previous, parent }) => {
  const current = parent.values.collectionId || "";

  if (!current || current === slugOf(previous)) {
    parent.setValues({ collectionId: slugOf(value) });
  }
};

const CREATE_FIELDS = {
  "/Public/BlogCollection/Create": {
    fields: [
      { property: "title", onChange: followTitle },
      "collectionId",
    ],
  },
};

const INITIAL = { title: "", collectionId: "" };

export const Sidebar = () => null;
export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();

  return (
    <Mutation
      initial={INITIAL}
      target={{ $ref: "/Public/BlogCollection/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update()}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={(data) => {
        const created = data && data.viewer.account.sites.get.blog.collections.create;
        history.replace(created ? `${base}/${created.collectionId}/edit` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
